<template>
  <v-container>
    <v-row class="align-center no-gutters">
      <v-col cols="11">
        <smart-input dense rounded outlined required :label="label" v-model="answer.content" hide-details>
        </smart-input>
      </v-col>
      <v-col>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <trash-icon-btn v-if="canRemove" class="pa-1" @click="$emit('remove',answer)" v-bind="attrs"
                            v-on="on" />
          </template>
          <span>הסרת התשובה</span>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row>
      <media-gallery v-if="media" @selected="selectedImage" />
      <v-img v-if="media" :src="answer.media_src" max-width="75"></v-img>
    </v-row>
  </v-container>
</template>

<script>
import MediaGallery from "dev/packages/gallery/MediaGallery";
import TrashIconBtn from "dev/components/TrashIconBtn";

export default {
  name: "answer-form",
  props: {
    answer: { type: Object, required: true },
    label: { default: "תשובה" },
    canRemove: { type: Boolean, default: true },
    media: { type: Boolean, default: false }
  },
  components: { MediaGallery, TrashIconBtn },
  data() {
    return {};
  },
  computed: {
    headerColor() {
      if (this.label == "התשובה הנכונה") {
        return "success";
      } else if (this.label == "תשובה לא נכונה") {
        return "#a9a9a9";
      } else {
        return "#85afff";
      }
    }
  },
  methods: {
    selectedImage(img) {
      this.$emit('updatedAnswerImage', img);
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  updated() {
  },
  destroyed() {
  }
};
</script>

<style scoped>
.answer-image {

}
</style>
